import '@material/web/icon/icon.js'
import '@operato/dataset/ox-checklist-entry-form.js'

import gql from 'graphql-tag'
import { css, html, LitElement } from 'lit'
import { customElement, property, query, state } from 'lit/decorators.js'

import { client } from '@operato/graphql'
import { i18next, localize } from '@operato/i18n'
import { CommonHeaderStyles, ScrollbarStyles } from '@operato/styles'
import { DataSet } from '@operato/dataset'
import { OxChecklistEntryForm } from '@operato/dataset/ox-checklist-entry-form.js'

@customElement('checklist-entry-form')
export class ChecklistEntryForm extends localize(i18next)(LitElement) {
  static styles = [
    CommonHeaderStyles,
    ScrollbarStyles,
    css`
      :host {
        display: flex;
        flex-direction: column;

        background-color: var(--md-sys-color-surface);
      }

      ox-checklist-entry-form {
        flex: 1;
        padding: 10px;
        overflow: auto;
      }

      .footer span {
        font-size: 0.8em;
        color: var(--md-sys-color-on-surface);
        line-height: 1.5;
        padding: 10px;
      }
    `
  ]

  @property({ type: Object }) dataSet?: DataSet & { id: string; entryType?: string }

  @state() dataSample?: { id: string; collectedAt: Date }

  @query('ox-checklist-entry-form') entryForm?: OxChecklistEntryForm

  render() {
    return html`
      <ox-checklist-entry-form .dataSet=${this.dataSet}></ox-checklist-entry-form>

      <div class="footer">
        <div filler></div>
        ${!this.dataSample
          ? html`
              <button @click=${this.updateDataItems.bind(this)} done>
                <md-icon>save</md-icon>${i18next.t('button.save')}
              </button>
            `
          : html` <span>${i18next.t('field.collected-at')}: ${this.dataSample.collectedAt.toLocaleString()}</span> `}
      </div>
    `
  }

  private async updateDataItems() {
    //@ts-ignore TODO replace with following line and confirm
    const data = this.entryForm.buildValue()

    const dataSample = {
      dataSet: {
        id: this.dataSet?.id
      },
      data
    } as any

    if (this.dataSample?.collectedAt) {
      dataSample.collectedAt = this.dataSample.collectedAt
    }

    const response = await client.mutate({
      mutation: gql`
        mutation ($dataSample: NewDataSample!) {
          createDataSample(dataSample: $dataSample) {
            id
            collectedAt
          }
        }
      `,
      variables: {
        dataSample
      },
      context: {
        hasUpload: true
      }
    })

    if (!response.errors) {
      const { id, collectedAt } = response.data.createDataSample
      this.dataSample = {
        id,
        collectedAt: new Date(collectedAt)
      }

      document.dispatchEvent(
        new CustomEvent('notify', { detail: { message: i18next.t('text.data sample created successfully') } })
      )
    }
  }
}
